<template>
  <div class="app-user-info">
    <div class="app-user-customer-info" v-if="currentCustomer.contract.msisdn">
      <span class="salutation text-primary d-block"><slot name="txtWelcome">Hallo </slot> {{currentCustomer.salutation}} {{currentCustomer.lastName}}!</span>
      <span class="msisdn d-block"><slot name="labelPhoneNumber"> Ihre Rufnummer: </slot> {{currentCustomer.contract.msisdn}}</span>
      <span class="balance d-block"><slot name="labelBalance">Ihr Kontostand: </slot> {{formattedBalance}}</span>
      <span class="contract-id d-block"><slot name="labelAccountNumber">Ihre Kundennummer: </slot> {{currentCustomer.contract.contractId}}</span>
    </div>
    <LogOut>
      <template v-for="slot in possibleChildSlotsFor('Logout')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </LogOut>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { wrapQuery } from '../../../../../helper/wrapGQLQuery'
import LogOut from '../LogOut/LogOut.vue'
import transaction from '@/mixins/transaction'
import slotProxy from '../../../../../mixins/slotProxy'
import price from '@/mixins/price'
export default {
  name: 'UserInfo',
  components: {
    LogOut
  },
  mixins: [
    transaction('userInfo'),
    slotProxy(),
    price
  ],
  computed: {
    formattedBalance () {
      if (this.currentCustomer.balance === null) {
        return '-'
      }
      return this.price(this.currentCustomer.balance)
    }
  },
  data () {
    return {
      currentCustomer: {
        balance: null,
        lastName: '',
        salutation: '',
        contract: {
          msisdn: '',
          contractId: ''
        }
      }
    }
  },
  apollo: {
    currentCustomer: function () {
      return wrapQuery(
        gql`query userInfo {
          currentCustomer {
            balance
            lastName
            salutation
            contract {
              msisdn
              contractId
            }
          }
        }`, this, 'currentCustomer'
      )
    }
  }
}
</script>
